import { ApiService } from '../api.service';

export abstract class Relation {

    protected static map: { [key: string]: ApiService } = {};

    /**
     * Add model service morph maps.
     *
     * @param {{[p: string]: ApiService}} map
     *
     * @return {{[p: string]: ApiService}}
     */
    public static morphMap(map: { [key: string]: ApiService }): { [key: string]: ApiService } {
        return this.map = Object.assign(this.map, map);
    }

    /**
     * Get the morphed model service.
     *
     * @param {string} name
     *
     * @return {ApiService | null}
     */
    public static getMorphed(name: string): ApiService | null {
        return this.map[name]
            || null;
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/api/relations/relation.ts